import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  userFormIndication: string = 'login';
  BASE_LOGIN: any = '';
  flowContext: {
    authMode: string;
    signupVerified?: boolean;
    passwordReset: boolean;
    email: string;
    directPasswordSetup?: boolean;
  } | null = null;

  constructor() {
    this.BASE_LOGIN = `${AppSettings.BASE_LOGIN}`;
  }

  navigateForm(event: any) {
    // ✅ If login emits an object with form + context, unpack it
    if (event && typeof event === 'object' && event.form) {
      this.userFormIndication = event.form;
      this.flowContext = event.context ?? null;
    } else {
      // plain string emission (signup, forgotpass, login) — no context needed
      this.userFormIndication = event;
      this.flowContext = null;
    }
  }
}
